import { render, staticRenderFns } from "./CardApartmentPlan.vue?vue&type=template&id=503fe4ba&scoped=true&"
import script from "./CardApartmentPlan.vue?vue&type=script&lang=js&"
export * from "./CardApartmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./CardApartmentPlan.vue?vue&type=style&index=0&id=503fe4ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fe4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503fe4ba')) {
      api.createRecord('503fe4ba', component.options)
    } else {
      api.reload('503fe4ba', component.options)
    }
    module.hot.accept("./CardApartmentPlan.vue?vue&type=template&id=503fe4ba&scoped=true&", function () {
      api.rerender('503fe4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/CardApartmentPlan.vue"
export default component.exports